import React, {useEffect,useState} from 'react'
import { Link } from 'react-router-dom';

export default function CommentItem(props) {
    return (
        <ul class="widget-list-item">
							<div class="widget-list-media">
                                <div class="user">
								<img alt="" src={`api/General/Image/${props.userName}`} />
                                </div>
							</div>
							<div class="widget-list-content">
								<h4 class="widget-list-title">
									<a href="#">
								{props.Lang =='ar' ? props.nameArabic:props.nameEnglish}
								</a></h4>
								<p class="widget-list-desc">{props.comment}</p>
							</div>
							<ul class="widget-list-action text-nowrap text-grey-darker">
                                <span class="d-none d-md-block">
                                {props.createDate}
                                </span>
                                <span class="d-md-none d-sm-block">
								{props.createDate}
                                {/* 02:25 PM <br/> 10 Jan 2019 */}
                                </span>

								<a href="#" data-toggle="dropdown" class="text-muted pull-right" aria-expanded="false">
									<i class="fa fa-ellipsis-h f-s-14"></i>
									</a>
								<ul class="dropdown-menu dropdown-menu-right">
                                    <li><a href="#"><i class="fas fa-fw m-r-10 fa-star text-yellow"></i> Highlight</a></li>
									<li><a href="#"><i class="far fa-fw m-r-10 fa-trash-alt text-red"></i> Remove Comment</a></li>
									
									
								</ul>
							</ul>
						</ul>
    )
}


// WEBPACK FOOTER //
// ./src/pages/course/Community/CommentItem.js